import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useReactivateGiftCardMutation = createMutationHook(
  GiftCardsApiClient.reactivateGiftCard,
  {
    mutationKey: ['reactivateGiftCard'],
  },
)
